import { BronzeTierIcon } from "./BronzeTierIcon";
import { SilverTierIcon } from "./SilverTierIcon";
import { GoldTierIcon } from "./GoldTierIcon";
import { DiamondTierIcon } from "./DiamondTierIcon";

function getTierIcon(tierIndex: number) {
  switch (tierIndex) {
    case 0:
      return <BronzeTierIcon />;
    case 1:
      return <SilverTierIcon />;
    case 2:
      return <GoldTierIcon />;
    case 3:
      return <DiamondTierIcon />;
    default:
      return null;
  }
}

export default getTierIcon;
